/**
 * ⛔ s523 — РАСПОЗНАВАНИЕ ПРОПАВШЕГО КУСКА СБОРКИ И ОДНА ПЕРЕЗАГРУЗКА.
 *
 * Живёт отдельным файлом от границы (`UstarevshiyKusok.tsx`) намеренно: правило
 * проекта требует, чтобы файл с компонентом экспортировал только компоненты, —
 * иначе горячая перезагрузка в разработке перестаёт работать. Это же деление
 * оказалось удобным и для ловушки: распознаватель проверяется без React.
 *
 * Что было. Страницы панели грузятся кусками, у каждого куска в имени хэш
 * сборки. Выкат заменяет папку целиком — старых имён на диске не остаётся.
 * Открытая вкладка продолжает жить старым кодом и при первом же переходе
 * просит файл, которого больше нет: обещание отклоняется, границы над
 * маршрутами не было ВОВСЕ — белый экран до ручного F5. В приборе это 27 issue
 * с июня по сентябрь; владелец видел их как «панель пропала после обновления».
 */

const KLYUCH = 'opsmind:kusok-perezagruzka';
const OKNO_MS = 60_000;

/** Текст отказа, которым браузеры называют непришедший кусок сборки. */
export function etoUstarevshiyKusok(oshibka: unknown): boolean {
  const text = oshibka instanceof Error
    ? `${oshibka.name} ${oshibka.message}`
    : String(oshibka ?? '');

  return /dynamically imported module|Importing a module script failed|Unable to preload CSS|ChunkLoadError|error loading dynamically/i.test(text);
}

/**
 * Перезагрузка не чаще раза в минуту.
 *
 * ⛔ Защита от петли. Если после перезагрузки кусок всё равно не пришёл (сеть,
 * прокси, отвалившийся сервер), страница не крутится по кругу, а честно
 * показывает, что случилось. Отметка живёт в sessionStorage; приватное окно без
 * хранилища получает одну перезагрузку — это всё равно лучше белого экрана.
 */
export function perezagruzitOdinRaz(): boolean {
  try {
    const bylo = Number(sessionStorage.getItem(KLYUCH) ?? '0');
    if (Date.now() - bylo < OKNO_MS) {
      return false;
    }
    sessionStorage.setItem(KLYUCH, String(Date.now()));
  } catch {
    // Хранилища нет — идём на одну перезагрузку.
  }

  perezagruzkaIdet = true;
  window.location.reload();

  return true;
}

/**
 * ⛔ s723 — ПОКА СТРАНИЦА ПЕРЕЗАГРУЖАЕТСЯ, ЕЁ ОШИБКИ В ПРИБОР НЕ ИДУТ.
 *
 * Перезагрузка занимает доли секунды, и за это время `React.lazy` успевает упасть на
 * заглушённом отказе куска («reading 'default'», «e._result is undefined»). Человек этого
 * не видит — страница уже уходит, — а прибор получал новую ошибку на каждую сборку (у
 * куска новое имя — у ошибки новый отпечаток), и сторож новой ошибки будил владельца
 * после каждого выката: issue 448, 456, 460 за 05–06.10.2026.
 */
let perezagruzkaIdet = false;

export function idetPerezagruzka(): boolean {
  return perezagruzkaIdet;
}

/**
 * ⛔ s042 — ОШИБКУ ГЛУШИМ, ТОЛЬКО ЕСЛИ ПЕРЕЗАГРУЗКА ДЕЙСТВИТЕЛЬНО ПОШЛА.
 *
 * Слушатель `vite:preloadError` звал `preventDefault()` всегда. Vite при этом
 * проглатывает отказ и отдаёт ленивому импорту `undefined` — `React.lazy` падает
 * «e._result is undefined» (GlitchTip ADMIN-1Q…21). Хуже всего во второй раз за
 * минуту: перезагрузки нет, а отказ проглочен — белый экран вместо объясняющей
 * границы `UstarevshiyKusok`.
 */
export function naOtkazKuska(event: Event): void {
  if (perezagruzitOdinRaz()) {
    event.preventDefault();
  }
}
